import { createSelector } from 'reselect';
import {
    PREVET_LOAD,
    PREVET_SUCCESS,
    PREVET_FAILURE,
    PREVET_UPDATE_LOAD,
    PREVET_UPDATE_SUCCESS,
    PREVET_UPDATE_FAILURE
} from './prevetActions';

const initialState = {
    prevet: {},
    loading: false,
    error: null,
    updateLoading: false,
    updateError: null,
    updateSuccessful: false
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case PREVET_LOAD:
            return {
                ...state,
                loading: true,
                error: null
            };

        case PREVET_SUCCESS:
            return {
                ...state,
                prevet: action.prevet,
                loading: false,
                error: null
            };

        case PREVET_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case PREVET_UPDATE_LOAD:
            return {
                ...state,
                updateLoading: true,
                updateError: null,
                updateSuccessful: false
            };

        case PREVET_UPDATE_SUCCESS:
            return {
                ...state,
                prevet: action.prevet,
                updateLoading: false,
                updateError: null,
                updateSuccessful: true
            };

        case PREVET_UPDATE_FAILURE:
            return {
                ...state,
                updateLoading: false,
                updateError: action.error,
                updateSuccessful: false
            };

        default:
            return state;
    }
}

export const getPrevetEntity = (state) => state.entities.prevet;

export const getPrevet = createSelector(
    [getPrevetEntity],
    (prevetEntity) => prevetEntity.prevet
);

export const getIsPrevetLoading = createSelector(
    [getPrevetEntity],
    (prevetEntity) => prevetEntity.loading
);

export const getPrevetErrorMessage = createSelector(
    [getPrevetEntity],
    (prevetEntity) => prevetEntity.error
);

export const getIsPrevetUpdateLoading = createSelector(
    [getPrevetEntity],
    (prevetEntity) => prevetEntity.updateLoading
);

export const getPrevetUpdateErrorMessage = createSelector(
    [getPrevetEntity],
    (prevetEntity) => prevetEntity.updateError
);

export const getIsPrevetUpdateSuccessful = createSelector(
    [getPrevetEntity],
    (prevetEntity) => prevetEntity.updateSuccessful
);

